import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams } from "react-router-dom";

export default function ViewReasoningQuestion() {

  const { id } = useParams();
  const [q, setQ] = useState(null);

  useEffect(() => {
    api.get(`/admin/reasoning/question/${id}`)
      .then(res => setQ(res.data));
  }, [id]);

  if (!q) return <p>Loading...</p>;

  return (
    <div>
      <h2>Reasoning Question #{q.id}</h2>
      <img src={q.question_image} width="200" />
      <p>A: {q.option_a}</p>
      <p>B: {q.option_b}</p>
      <p>C: {q.option_c}</p>
      <p>D: {q.option_d}</p>
      <b>Correct: {q.correct}</b>
    </div>
  );
}
